import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import Homepage from "./pages/Homepage";
import Products from "./data/products.json";
import Contactpage from "./pages/Contactpage";
import MarketPlacePage from "./pages/MarketPlacePage";
import CategoryPage from "./pages/CategoryPage";
import SubCategoryPage from "./pages/SubcategoryPage";
import ProductsPage from "./pages/ProductsPage";
import EwastePage from "./pages/EwastePage";
import GalleryPage from "./pages/GalleryPage";
import CEODeskPage from "./pages/CEODeskPage";
import ThankYou from "./pages/Thankyoupage";
import PartnerPage from "./pages/PartnerPage";
import AboutUsPage from "./pages/AboutUsPage";
import CareersPage from "./pages/CareerPage";
import Error from "./pages/ErrorPage";
import TestimonialsPage from "./pages/TestimonialsPage";
import PrivacyPolicy from "./pages/PrivacyPolicyPage";
import TermsPage from "./pages/TermsPage";
import DisclaimerPage from "./pages/DisclaimerPage";
import NewsletterPage from "./pages/NewsletterPage";
import CertificatePage from "./pages/CertificatePage";
import DownloadPage from "./pages/DownloadPage";
import { ToastContainer } from "react-bootstrap";
import Complaint from "./components/Complaint";
import PopupPromotion from "./components/PopupPromotion";
import QuickCall from "./components/QuickCall";
import BlogsAdmin from "./components/adminpanel/blogsadmin";
import BlogsPage from "./pages/BlogsPage";
import { initGA, trackPageView } from "./utils/ga";
import ChatbotComponent from "./components/Chatbot";
import LandingBaggage from "./components/LandingBaggage";
import LandingBaggagePage from "./pages/LandingBaggagePage";
import BlogDetails from "./pages/BlogDetails";
import TimeAttendancePage from "./pages/TimeAttendancePage";
import ComplaintForm from "./components/ComplaintForm";
import ThankYou2 from "./pages/Thankyoupage2";

function TrackPageView() {
  const location = useLocation();

  useEffect(() => {
    initGA();
    trackPageView(location.pathname);
  }, [location]);

  return null;
}

// ✅ Move Layout logic to a separate component
function Layout({ children }) {
  const location = useLocation();
  const hideOnPages = ["/baggage-scanner", "/thank-you"]; // Pages where QuickCall should be hidden

  return (
    <>
      
      {children}
      <ToastContainer />
      {/* Hide QuickCall on specific pages */}
      {!hideOnPages.includes(location.pathname) && (
        <>
         <QuickCall />
         {/* <PopupPromotion /> */}
        </>
      )}
    </>
  );
}

function App() {
  return (
    <>
      <Router>
        <TrackPageView />
        {/* <Complaint /> */}
        <div className="App">
          <Layout>
            <Routes>
              <Route path="/baggage-scanner" element={<LandingBaggagePage />} />
              <Route path="/time-attendance" element={<TimeAttendancePage />} />
              <Route path="/" element={<Homepage />} />
              <Route path="/products" element={<Products />} />
              <Route path="/contact-us" element={<Contactpage />} />
              {/* <Route path="/newsflash" element={<NewsletterPage />} /> */}
              <Route path="/testimonials" element={<TestimonialsPage />} />
              <Route path="/ceo-desk" element={<CEODeskPage />} />
              <Route path="/market-place" element={<MarketPlacePage />} />
              <Route
                path="/market-place/:category"
                element={<CategoryPage />}
              />
              <Route
                path="/market-place/:category/:subcategory"
                element={<SubCategoryPage />}
              />
              <Route
                path="/market-place/:category/:subcategory/:product"
                element={<ProductsPage />}
              />
              <Route path="/gallery/:categoryName" element={<GalleryPage />} />
              <Route path="/about-us" element={<AboutUsPage />} />
              <Route path="/thank-you" element={<ThankYou />} />
              <Route path="/thankyou" element={<ThankYou2 />} />
              <Route path="/error" element={<Error />} />
              <Route path="/become-partner" element={<PartnerPage />} />
              <Route path="/careers" element={<CareersPage />} />
              <Route path="/e-waste" element={<EwastePage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-conditions" element={<TermsPage />} />
              <Route path="/disclaimer" element={<DisclaimerPage />} />
              <Route path="/certifications" element={<CertificatePage />} />
              <Route path="/downloads" element={<DownloadPage />} />

              {/* UAE Routes */}
              <Route path="/uae" element={<Homepage />} />
              <Route path="/uaecontact-us" element={<Contactpage />} />
              <Route path="/uaenewsflash" element={<NewsletterPage />} />
              <Route path="/uaetestimonials" element={<TestimonialsPage />} />
              <Route path="/uaeceo-desk" element={<CEODeskPage />} />
              <Route path="/uaemarket-place" element={<MarketPlacePage />} />
              <Route
                path="/uaemarket-place/:category"
                element={<CategoryPage />}
              />
              <Route
                path="/uaemarket-place/:category/:subcategory"
                element={<SubCategoryPage />}
              />
              <Route
                path="/uaemarket-place/:category/:subcategory/:product"
                element={<ProductsPage />}
              />
              <Route
                path="/uaegallery/:categoryName"
                element={<GalleryPage />}
              />
              <Route path="/uaeabout-us" element={<AboutUsPage />} />
              <Route path="/uaethank-you" element={<ThankYou />} />
              <Route path="/uaeerror" element={<Error />} />
              <Route path="/uaebecome-partner" element={<PartnerPage />} />
              <Route path="/uaecareers" element={<CareersPage />} />
              <Route path="/uaee-waste" element={<EwastePage />} />
              <Route path="/uaeprivacy-policy" element={<PrivacyPolicy />} />
              <Route path="/uaeterms-conditions" element={<TermsPage />} />
              <Route path="/uaeterms-conditions" element={<TermsPage />} />
              <Route path="/uaedisclaimer" element={<DisclaimerPage />} />
              <Route path="/uaecertifications" element={<CertificatePage />} />
              <Route path="/uaedownloads" element={<DownloadPage />} />
              <Route path="/blog" element={<BlogsPage />} />
              <Route path="/blog/:id" element={<BlogDetails />} />
              <Route path="/support" element={<ComplaintForm />} />

              {/* Admin Routes */}
              <Route path="/admin/blogs" element={<BlogsAdmin />} />
            </Routes>
          </Layout>
        </div>
      </Router>
    </>
  );
}

export default App;
